import React, { useState,useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { setYearList,setMonthList,setDateRange,formatDate,DownloadFile } from './Function';
import { Row,Col,Card,Accordion,Tab,Tabs,Table, Button,Placeholder,Form } from 'react-bootstrap';
const SchemeSyllabusArchive = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const[ProgramGroups,setGroups]=useState([]);
    const[syllabusCbsc,setSyllabusCbsc]=useState([]);
    const[syllabusNonCbsc,setSyllabusNonCbsc]=useState([]);
    const[isLoading, setLoading] = useState(true);
    const[isCbscLoading, setCbscLoading] = useState(true);
    const[isNonCbscLoading, setNonCbscLoading] = useState(true);
    const[year, setYear] = useState(0);
    const[month, setMonth] = useState(0);
    const YearChange = (e) => setYear(Number(e.target.value) || 0);
    const MonthChange = (e) => setMonth(Number(e.target.value) || 0);
    useEffect(()=>
    {
        const getProgramGroup = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"programsGroup/all");
                const result = await response.json();
                setGroups(result);
                setLoading(false);
                if( global.config.IsPrint === true ) { console.info('Program Groups : Result',result); }
              
            } catch (error) 
            {
                console.error('Program Groups : Error', error.message);
            }
        };
        getProgramGroup();
        SyllabusCbscList('',1);
        SyllabusCbscList('',2);
        // eslint-disable-next-line
    },[])
    const SyllabusCbscList = async (e,cbsc) => 
    {
        if (e)
        {
            e.preventDefault();
            if (year === 0 && month === 0) 
            {
                alert(t('FilterAlert'));
                return;
            }
        }
        try 
        {
            if( cbsc === 1 )
            {
                setCbscLoading(false);                            
            }
            if( cbsc === 2 )
            {
                setNonCbscLoading(false);
            }
            const { startDate, endDate } = setDateRange(year, month, 0, 1, 0);
            const callApi = global.config.API_URL + `schemeSyllabus/list/0/0/${cbsc}/${startDate}/${endDate}`;
            if(global.config.IsPrint) console.info('SyllabusList : API', callApi);
            const response = await fetch(callApi);
            const result = await response.json();
            if( result.length > 0 )
            {
                Promise.all(
                    result.map(e => {
                        const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.ps_id+"/psSyllabus")
                            .then(upp => upp.json());
                        const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.ps_id+"/psSyllabusHi")
                            .then(upph => upph.json());
                        return Promise.all([fetch1, fetch2])
                            .then(([upp,upph]) => {
                                return {
                                    ...e,
                                    upp,
                                    upph
                                };
                            });
                    })
                ).then(allResponse => {   
                    allResponse.forEach((el, i) => {
                        result[i].psSyllabus = el.upp;
                        result[i].psSyllabusHi = el.upph;                            
                    });
                    if( cbsc === 1 )
                    {
                        setSyllabusCbsc(result);
                        setCbscLoading(false);                            
                    }
                    if( cbsc === 2 )
                    {
                        setSyllabusNonCbsc(result);
                        setNonCbscLoading(false);
                    }                
                }).catch(error => 
                {
                    console.error('SyllabusCbscList: Error', error);
                    if( cbsc === 1 )
                    {
                        setCbscLoading(false);
                    }
                    if( cbsc === 2 )
                    {
                        setNonCbscLoading(false);
                    }
                }); 
            }
            else
            {
                if( cbsc === 1 )
                {
                    setSyllabusCbsc([]);
                    setCbscLoading(false);
                }
                if( cbsc === 2 )
                {
                    setSyllabusNonCbsc([]);
                    setNonCbscLoading(false);
                }
            }
            if( global.config.IsPrint === true ) { console.info('SyllabusCbscList '+cbsc+' : Result',result); }
            
        } 
        catch (error) 
        {
            console.error('SyllabusCbscList '+cbsc+' : Error', error.message);
            if( cbsc === 1 )
            {
                setCbscLoading(false);
            }
            if( cbsc === 2 )
            {
                setNonCbscLoading(false);
            }
        }
    };
    return (
        <React.Fragment>
        {isLoading ? (
        <React.Fragment>
        {[...Array(1)].map((_, index) => (
            <Card className=' mb-4' key={index}>
                <Card.Header className='text-center fs-3'><Placeholder xs={6} /></Card.Header>
                <Card.Body>
                <Accordion defaultActiveKey={[0]} alwaysOpen>
                {[...Array(3)].map((_, index)=>(
                <Accordion.Item eventKey={index} key={index}>
                    <Accordion.Header><Placeholder xs={6} /></Accordion.Header>
                    <Accordion.Body>
                        <Tabs defaultActiveKey="0">
                        {[...Array(5)].map((_, index)=>(
                        <Tab eventKey={index} key={index} title={<Placeholder xs={10} />}>
                            <Card className=' mb-3'>
                                <Card.Body>
                                    <div className='mb-2 fw-bold'><Placeholder xs={3} /></div>
                                    <Row>
                                        <Col md={4} data-aos="fade-right" data-aos-duration="1000">
                                            <Placeholder xs={12} />
                                        </Col>
                                        <Col md={4} data-aos="fade-right" data-aos-duration="1000">
                                            <Placeholder xs={12} />
                                        </Col>
                                        <Col md={4} className='d-grid' data-aos="fade-left" data-aos-duration="1000">
                                            <Button className='btn btn-info' type='submit'><Placeholder xs={12} /></Button>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                            <Table responsive bordered className='rounded-top text-center overflow-hidden mb-0'>
                            <thead>
                                <tr>
                                    <th className="w-50"><Placeholder xs={12} /></th>
                                    <th><Placeholder xs={12} /></th>
                                    <th><Placeholder xs={12} /></th>
                                </tr>
                            </thead>
                            <tbody>
                                {[...Array(10)].map((_,index)=>(
                                <tr key={index}>
                                    <th className="table-success"><Placeholder xs={12} /></th>
                                    <td className="text-center">
                                        <Button className="btn btn-light w-75"><Placeholder xs={12} /></Button>
                                    </td>
                                    <td><Placeholder xs={12} /></td>
                                </tr>
                                ))}
                            </tbody>
                        </Table>                                   
                        </Tab>
                        ))}
                        </Tabs>
                    </Accordion.Body>
                </Accordion.Item>
                ))}
                </Accordion>
                </Card.Body>
            </Card>
        ))}
        </React.Fragment>
        ) : (
        <React.Fragment>
        {ProgramGroups.map((pg)=>(
        <Card className=' mb-4' key={pg.pg_id}>
            <Card.Header className='text-center fs-3'>{appLanguage === 'hi' ? pg.pg_name_hi || pg.pg_name : pg.pg_name}</Card.Header>
            <Card.Body>
                <ProgramType pgId={pg.pg_id} />
            </Card.Body>
        </Card>
        ))}
        <Card className='mb-4'>
        <Card.Header className='text-center fs-3'>{appLanguage === 'hi' ? 'पाठ्यक्रम' : 'SYLLABUS'}</Card.Header>
        <Card.Body>
            <Accordion defaultActiveKey={['0']} alwaysOpen>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>{appLanguage === 'hi' ? 'समस्त पाठ्यक्रम-CBCS' : 'All Syllabus-CBCS'}</Accordion.Header>
                    <Accordion.Body>
                        <Tabs defaultActiveKey="all">
                            <Tab eventKey="all" title={appLanguage === 'hi' ? 'सभी' : 'ALL'}>
                                <Card className=' mb-3'>
                                    <Card.Body>
                                        <form onSubmit={(e) => SyllabusCbscList(e, 1)}>
                                        <div className='mb-2 fw-bold'>{t('FilterSearch')}</div>
                                        <Row className='g-2'>
                                            <Col md={4} data-aos="fade-right" data-aos-duration="1000">
                                                <Form.Select onChange={YearChange} value={year}>
                                                    <option value={0}>{t('FilterYear')}</option>
                                                    {setYearList(0,1).map((year) => (
                                                    <option key={year} value={year}>
                                                        {year}
                                                    </option>
                                                    ))}
                                                </Form.Select>
                                            </Col>
                                            <Col md={4} data-aos="fade-right" data-aos-duration="1000">
                                                <Form.Select onChange={MonthChange} value={month}>
                                                    <option value={0}>{t('FilterMonth')}</option>
                                                    {setMonthList().map(({ value, label }) => (
                                                    <option key={value} value={value}>
                                                        {label}
                                                    </option>
                                                    ))}
                                                </Form.Select>
                                            </Col>
                                            <Col md={4} className='d-grid' data-aos="fade-left" data-aos-duration="1000">
                                                <Button className='btn btn-info' type='submit'><i className="bi bi-search"></i> {t('FilterSearch')}</Button>
                                            </Col>
                                        </Row>
                                        </form>
                                    </Card.Body>
                                </Card>
                                <Table responsive bordered className='rounded-top text-center overflow-hidden mb-0'>
                                    <thead>
                                        <tr>
                                            <th className="w-50">{appLanguage === 'hi' ? 'पाठ्यक्रम (वर्षवार)' : 'Syllabus (Year-Wise)'}</th>
                                            <th>{t('UploadDate')}</th>
                                            <th>{t('Download')}</th>                                          
                                        </tr>
                                    </thead>
                                    {isCbscLoading ? (
                                    <tbody>
                                        {[...Array(10)].map((_,index)=>(
                                        <tr key={index}>
                                            <th className="table-success"><Placeholder xs={12} /></th>
                                            <td><Placeholder xs={12} /></td>
                                            <td className="text-center">
                                                <Button className="btn btn-light w-75"><Placeholder xs={12} /></Button>
                                            </td>                                            
                                        </tr>
                                        ))}                                      
                                    </tbody>
                                    ) : (
                                    <tbody>
                                        {syllabusCbsc.map((ps,index)=>(
                                        <tr key={index}>
                                            <th className="table-success" dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? (ps.ps_display_en === "1" ? ps.ps_name_hi || '' : ps.ps_name_hi || ps.ps_name) : ps.ps_name}}></th>                                            
                                            <td>{formatDate(ps.ps_date)}</td>
                                            <td className="text-center" dangerouslySetInnerHTML={{ __html: DownloadFile(appLanguage,ps.psSyllabus,ps.psSyllabusHi)}} />
                                        </tr>
                                        ))}                                      
                                    </tbody>
                                    )}                                           
                                </Table>                                   
                            </Tab>                                
                        </Tabs>                        
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                    <Accordion.Header>{appLanguage === 'hi' ? 'समस्त पाठ्यक्रम-गैर सीबीसीएस' : 'All Syllabus-NON CBCS'}</Accordion.Header>
                    <Accordion.Body>
                        <Tabs defaultActiveKey="all">
                            <Tab eventKey="all" title="ALL">
                                <Card className=' mb-3'>
                                    <Card.Body>
                                    <form onSubmit={(e) => SyllabusCbscList(e, 2)}>
                                        <div className='mb-2 fw-bold'>{t('FilterSearch')}</div>
                                        <Row className='g-2'>
                                            <Col md={4} data-aos="fade-right" data-aos-duration="1000">
                                                <Form.Select onChange={YearChange} value={year}>
                                                    <option value={0}>{t('FilterYear')}</option>
                                                    {setYearList(0,1).map((year) => (
                                                    <option key={year} value={year}>
                                                        {year}
                                                    </option>
                                                    ))}
                                                </Form.Select>
                                            </Col>
                                            <Col md={4} data-aos="fade-right" data-aos-duration="1000">
                                                <Form.Select onChange={MonthChange} value={month}>
                                                    <option value={0}>{t('FilterMonth')}</option>
                                                    {setMonthList().map(({ value, label }) => (
                                                    <option key={value} value={value}>
                                                        {label}
                                                    </option>
                                                    ))}
                                                </Form.Select>
                                            </Col>
                                            <Col md={4} className='d-grid' data-aos="fade-left" data-aos-duration="1000">
                                                <Button className='btn btn-info' type='submit'><i className="bi bi-search"></i> {t('FilterSearch')}</Button>
                                            </Col>
                                        </Row>
                                        </form>
                                    </Card.Body>
                                </Card>
                                <Table responsive bordered className='rounded-top text-center overflow-hidden mb-0'>
                                    <thead>
                                        <tr>
                                            <th className="w-50">{appLanguage === 'hi' ? 'पाठ्यक्रम (वर्षवार)' : 'Syllabus (Year-Wise)'}</th>
                                            <th>{t('UploadDate')}</th>
                                            <th>{t('Download')}</th>
                                        </tr>
                                    </thead>
                                    {isNonCbscLoading ? (
                                    <tbody>
                                        {[...Array(10)].map((_,index)=>(
                                        <tr key={index}>
                                            <th className="table-success"><Placeholder xs={12} /></th>
                                            <td><Placeholder xs={12} /></td>
                                            <td className="text-center">
                                                <Button className="btn btn-light w-75"><Placeholder xs={12} /></Button>
                                            </td>                                            
                                        </tr>
                                        ))}                                      
                                    </tbody>
                                    ) : (
                                    <tbody>
                                        {syllabusNonCbsc.map((ps,index)=>(
                                        <tr key={index}>
                                            <th className="table-success" dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? (ps.ps_display_en === "1" ? ps.ps_name_hi || '' : ps.ps_name_hi || ps.ps_name) : ps.ps_name}}></th>                                            
                                            <td>{formatDate(ps.ps_date)}</td>
                                            <td className="text-center" dangerouslySetInnerHTML={{ __html: DownloadFile(appLanguage,ps.psSyllabus,ps.psSyllabusHi)}} />
                                        </tr>
                                        ))}                                      
                                    </tbody>
                                    )}                                            
                                </Table>                                   
                            </Tab>                                
                        </Tabs>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </Card.Body>
        </Card>
        </React.Fragment>
        )}
        </React.Fragment> 
    );    
}
export default SchemeSyllabusArchive;
const ProgramType = ({pgId}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[programType,setType]=useState([]);
    useEffect(()=>
    {
        const getProgramType = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"programsType/byProgramGroup/"+pgId);
                const result = await response.json();
                setType(result);
                if( global.config.IsPrint === true ) { console.info('Program Type : Result',result); }
              
            } catch (error) 
            {
                console.error('Program Type : Error', error.message);
            }
        };
        getProgramType();    
    },[pgId])
    return (
        <Accordion defaultActiveKey={[pgId + 0]} alwaysOpen>
        {programType.map((pt,index)=>(
            <Accordion.Item eventKey={pgId + index} key={index}>
                <Accordion.Header>
                    {appLanguage === 'hi' ? (pt.pt_display_en === "1" ? pt.pt_name_hi || '' : pt.pt_name_hi || pt.pt_name) : pt.pt_name}
                </Accordion.Header>
                <Accordion.Body>
                    <Programs ptId={pt.pt_id} />
                </Accordion.Body>
            </Accordion.Item>
        ))}
        </Accordion>       
    );
}
const Programs = ({ptId}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[programs,setPrograms]=useState([]);
    useEffect(()=>
    {
        const getPrograms = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"programs/programType/"+ptId);
                const result = await response.json();
                setPrograms(result);
                if( global.config.IsPrint === true ) { console.info('Programs : Result',result); }
              
            } catch (error) 
            {
                console.error('Programs : Error', error.message);
            }
        };
        getPrograms();    
    },[ptId])
    return (
        <Tabs defaultActiveKey="0">
            {programs.map((p,index)=>(
                <Tab eventKey={index} key={index} title={appLanguage === 'hi' ? (p.p_display_en === "1" ? p.p_short_name_hi || '' : p.p_short_name_hi || p.p_short_name) : p.p_short_name}>
                    <SchemeSyllabusByProgram pId={p.p_id} />                                   
                </Tab>
            ))}
        </Tabs>
    );
}
const SchemeSyllabusByProgram = ({pId}) =>
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const[isLoading, setLoading] = useState(true);
    const[SchemeSyllabus,setSchemeSyllabus]=useState([]);
    const[year, setYear] = useState(0);
    const[month, setMonth] = useState(0);
    const YearChange = (e) => setYear(Number(e.target.value) || 0);
    const MonthChange = (e) => setMonth(Number(e.target.value) || 0);
    useEffect(() => 
    {
        SchemeSyllabusList();
        // eslint-disable-next-line
    }, [pId]);
    const SchemeSyllabusList = async (e) => 
    {
        if (e)
        {
            e.preventDefault();
            if (year === 0 && month === 0) 
            {
                alert(t('FilterAlert'));
                return;
            }
        }
        try 
        {
            setLoading(true);
            const { startDate, endDate } = setDateRange(year, month, 1, 0, 0);
            const callApi = global.config.API_URL + `schemeSyllabus/list/${pId}/0/0/${startDate}/${endDate}`;
            if(global.config.IsPrint) console.info('SchemeSyllabusList : API', callApi);
            const response = await fetch(callApi);
            const result = await response.json();
            if (result.length > 0) {
                Promise.all(
                    result.map(e => {
                        const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.ps_id+"/psSyllabus")
                            .then(upp => upp.json());
                        const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.ps_id+"/psSyllabusHi")
                            .then(upph => upph.json());
                        return Promise.all([fetch1, fetch2])
                            .then(([upp,upph]) => {
                                return {
                                    ...e,
                                    upp,
                                    upph
                                };
                            });
                    })
                ).then(allResponse => {   
                    allResponse.forEach((el, i) => {
                        result[i].psSyllabus = el.upp;
                        result[i].psSyllabusHi = el.upph;                            
                    });
                    setSchemeSyllabus(result);
                    setLoading(false);
                }).catch(error => {
                    console.error('SchemeSyllabusList: Error', error);
                    setLoading(false);
                });
            } else {
                setSchemeSyllabus([]);
                setLoading(false);
            }            
            if( global.config.IsPrint === true ) { console.info('SchemeSyllabusList : Result',result); }
        }
        catch (error) { 
            console.error('SchemeSyllabusList : Error', error.message);
            setLoading(false);
        }
    };
    return (
    <React.Fragment>
        <Card className=' mb-3'>
            <Card.Body>
                <form onSubmit={SchemeSyllabusList}>
                    <div className='mb-2 fw-bold'>{t('FilterSearch')}</div>
                    <Row className='g-2'>
                        <Col md={4} data-aos="fade-right" data-aos-duration="1000">
                            <Form.Select onChange={YearChange} value={year}>
                                <option value={0}>{t('FilterYear')}</option>
                                {setYearList(1,0).map((year) => (
                                <option key={year} value={year}>
                                    {year}
                                </option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col md={4} data-aos="fade-right" data-aos-duration="1000">
                            <Form.Select onChange={MonthChange} value={month}>
                                <option value={0}>{t('FilterMonth')}</option>
                                {setMonthList().map(({ value, label }) => (
                                <option key={value} value={value}>
                                    {label}
                                </option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col md={4} className='d-grid' data-aos="fade-left" data-aos-duration="1000">
                            <Button className='btn btn-info' type='submit'><i className="bi bi-search"></i> {t('FilterSearch')}</Button>
                        </Col>
                    </Row>
                </form>
            </Card.Body>
        </Card>
        <Table responsive bordered className='rounded-top text-center overflow-hidden mb-0'>
        <thead>
            <tr>
                <th className="w-50">{appLanguage === 'hi' ? 'पाठ्यक्रम (वर्षवार)' : 'Syllabus (Year-Wise)'}</th>
                <th>{t('UploadDate')}</th>
                <th>{t('Download')}</th>
            </tr>
        </thead>
        {isLoading ? (
        <tbody>
            {[...Array(5)].map((_, index) => (
            <tr key={index}>
                <th className="table-success"><Placeholder xs={12} /></th>
                <td><Placeholder xs={12} /></td>
                <td className="text-center">
                    <Button className="btn btn-light w-75"><Placeholder xs={12} /></Button>
                </td>                
            </tr>
            ))}
        </tbody>
        ) : (
        <tbody>
            {SchemeSyllabus.map((ps,index)=>(
            <tr key={index}>
                <th className="table-success" dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? (ps.ps_display_en === "1" ? ps.ps_name_hi || '' : ps.ps_name_hi || ps.ps_name) : ps.ps_name}}></th>
                <td>{formatDate(ps.ps_date)}</td>
                <td className="text-center" dangerouslySetInnerHTML={{ __html: DownloadFile(appLanguage,ps.psSyllabus,ps.psSyllabusHi)}} />                
            </tr>
            ))}
        </tbody>
        )}
        </Table>
    </React.Fragment>
    );
}